export enum BusinessDomainConnectionTypes {
  Password = 0,
  Sso = 1
}
